import { useState } from 'react';
import { Link } from "react-router-dom";

const Header = ({ downloadLink }) => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((open) => !open);
  }

  return (
    <div className="overflow-x-hidden">
      <header className="pt-5 max-w-[1500px] mx-auto absolute left-0 right-0 top-0 z-50 navbar transition-all">
        <nav className={`px-6 lg:px-16 flex items-center justify-between header ${isOpen ? "nav-open" : ""}`}>
          <Link to="/">
            <img src="img/Logo.png" alt="" className="max-w-[150px]" />
          </Link>

          <div className="main-nav">
            <ul className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-6 main-nav-list text-white lg:text-[#4E6F7E]">
                <li><Link to="/" className="main-nav-link nav-scroll px-8 py-3 hover:bg-sky-100 transition-all duration-[0.5s]">Home</Link></li>
                <li><a href="https://blog.vent.africa/" target='_blank' rel="noopener noreferrer" className="main-nav-link nav-scroll px-8 py-3 hover:bg-sky-100 transition-all duration-[0.5s]">Blog</a></li>
                <li><Link to="/team" className="main-nav-link nav-scroll px-8 py-3 hover:bg-sky-100 transition-all duration-[0.5s]">Team</Link></li>
                <li><a href="https://t.me/ventafrica" target='_blank' rel="noopener noreferrer" className="main-nav-link nav-scroll px-8 py-3 hover:bg-sky-100 transition-all duration-[0.5s]">Community</a></li>
                <li><Link to="/support" className="main-nav-link nav-scroll px-8 py-3 hover:bg-sky-100 transition-all duration-[0.5s]">Support</Link></li>
            </ul>
          </div>

          <a href={downloadLink} target='_blank' rel="noopener noreferrer" className="hidden lg:block bg-[#2CB8F2] text-white px-10 py-3 rounded-md">Start Trading</a>

          <button className="btn-mobile-nav block lg:hidden" onClick={toggleMenu}>
              <div className="icon-mobile-nav text-gray-500 inline" name="open-menu">
                <img src="img/Frame 3936.png" alt="" className='max-w-[40px]' />
              </div>

            <div className="icon-mobile-nav text-white inline hidden" name="close-menu">
              <ion-icon style={{ fontSize: "50px" }} name="close-outline"></ion-icon>
            </div>

          </button>
        </nav>
      </header>
    </div>
  )
}

export default Header